import React, { Component } from 'react';
import { connect } from 'react-redux';
import { processForgotPasswordRequest } from 'actions';
import Input from 'components/partials/Fields/Input';
import FormTools from 'components/partials/Fields/FormTools';
import { general_error_toastr } from 'components/partials/Notification';
import { getQueryParam } from 'helpers/queryParams';
import DoRedirect from 'components/Page/DoRedirect';
import { GUEST } from 'Enums/middleware';
import 'styles/components/password-request.less';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

class ForgotPasswordRequest extends Component {
    static async getInitialProps() {
        const pageData = { title: 'Password Reset', h1: 'Password Reset', description: undefined, marginBottom: 'pageTitle marginB20' };

        return { pageData };
    }

    state = {
        email: '',
        formID: 'forgot-password',
        do_redirect: false,
        loading: false,
    };

    componentDidMount() {
        const email = getQueryParam('email');

        if (email) {
            const event = {
                target: {
                    name: 'email',
                    value: email,
                },
            };

            this.onChange(event);
        }
    }

    submitPreCheck = (e) => {
        e.preventDefault();
        const { formID } = this.state;

        const is_valid = (window.$(`#${formID}`).parsley().isValid());

        if (!is_valid) {
            general_error_toastr();
            return false;
        }
    };

    handleFormSubmit = () => {
        this.setState({ loading: true }, () => {
            this.props.processForgotPasswordRequest(this.state.email)
                .then(
                    () => this.setState({ do_redirect: true }),
                    () => this.setState({ loading: false, do_redirect: true }),
                );
        });
    };

    onChange = ({ target: { name, value } }) => this.setState({ [name]: value });

    render() {
        const { formID, email, loading, do_redirect } = this.state;

        if (do_redirect === true) {
            return <DoRedirect to="/account/reset-requested" />;
        }

        return (
            <Row className="forgot-password-request text-center">
                <Col md={{span: 8, offset: 2}}>
                    <div>
                        <p className="screaming">Forgot your password?</p>
                        <p className="instruction">We've got you covered. Enter your email address on file and we'll get you reset.</p>
                        <form id={formID} onSubmit={this.submitPreCheck} method="POST">
                            <FormTools
                                hasPassword
                                formID={formID}
                                onSubmit={this.handleFormSubmit}
                                validationFailed={() => {
                                    this.setState({ allowShowValidationToastr: false });
                                }}
                                allowShowValidationToastr={this.state.allowShowValidationToastr}
                            />
                            <Input type="email" name="email" label="Email Address" value={email} attributes={{ required: true }} updateMethod={this.onChange} />
                            <button id="forgot-password-submit" className="btn btn-blue btn-regular forgot-password-submit" type="submit" disabled={loading}>
                                {loading ? <i className="fa fa-spin fa-spinner" /> : null}
                                {' '}
                                Send Password Reset
                            </button>
                        </form>
                    </div>
                </Col>
            </Row>
        );
    }
}


const mapStateToProps = ({ user }) => {
    const { password_request_done = false } = user;

    return { password_request_done };
};

ForgotPasswordRequest.middleware = GUEST;

export default connect(mapStateToProps, { processForgotPasswordRequest })(ForgotPasswordRequest);